import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export interface Stamped<T> {
    data: T
    timestamp: number
}

export class Timestamp<V = any, E = any, C = any> extends Pass<V, E, C, Stamped<V>> {
    protected source?: AnySourceStream<V, E, C>

    value(value: V) {
        this._value({
            data: value,
            timestamp: Date.now(),
        })
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        timestamp(): Stream<DV, DE, DC, Stamped<DV>, DE, DC>
    }
}

Stream.prototype.timestamp = function <V, E, C>(this: AnySourceStream<V, E, C>) {
    return new Timestamp(this) // tslint:disable-line:no-invalid-this
}
